// creating an axios instance to make api calls
import axios from "axios";

// Get API URL from environment variables or fallback to localhost
const API_URL = process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8000/api/v1";

const axiosInstance = axios.create({
  baseURL: API_URL, // FastAPI backend URL
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials: true, // Include cookies if using authentication
});

// Add request interceptor to handle authentication or other common headers
axiosInstance.interceptors.request.use(
  (config) => {
    // Add authentication token from localStorage or sessionStorage
    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common error cases
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle different error states (401, 403, 500, etc.)
    if (error.response) {
      const { status } = error.response;

      // Log the error for debugging
      console.error(`API Error (${status}):`, error.response.data);

      // Handle specific error statuses
      if (status === 401) {
        // Clear stored tokens and redirect to login
        localStorage.removeItem('access_token');
        sessionStorage.removeItem('access_token');
        
        // Redirect to login page if not already there
        if (window.location.pathname !== '/authentication/sign-in') {
          window.location.href = '/authentication/sign-in';
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Network Error:", error.request);
    } else {
      // Something happened in setting up the request
      console.error("Request Error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
